export default "{\n    \"roleLabel\": \"Rol\"\n}"